import {common} from '@priority-software/priority-proto-api/lib';
import {getServerStoreData, setServerStoreData} from './proto/ServerStorage/service';

export const getSelectedFieldsData = async (key: string, defaultFields: string[]) => {
    const quantKey = key + '_quantKey';
    const res = await getServerStoreData([key + '*'], false, true);
    const parsedRes = res[quantKey] ? JSON.parse(res[quantKey].Str) : true; // true is default for the quant selector.

    return res[key]
        ? {selectedColumnsRes: JSON.parse(res[key].Str), quantSelectorRes: parsedRes}
        : {selectedColumnsRes: defaultFields, quantSelectorRes: parsedRes};
};

export const updateSelectedFieldsData = async (
    selectedFields: any[],
    shouldShowQuantitySelector: boolean,
    key: string
) => {
    const selectedFieldsToSave = new common.Constant({Str: JSON.stringify(selectedFields)});
    const quantKey = key + '_quantKey';
    const quantDataToSave = new common.Constant({Str: JSON.stringify(shouldShowQuantitySelector)});
    const fieldsStr = {[key]: selectedFieldsToSave, [quantKey]: quantDataToSave};
    return setServerStoreData(fieldsStr, true, false);
};
